<template>
	<div class="story-node" :style="nodeStyle" 
		@mousedown="handleMousedown"
		@mouseover="handleMouseOver"
		@mouseleave="handleMouseLeave"
		v-click-outside="hidePopover"
		v-bind:class="{selected: options.selected === id}">
		<div class="node-port node-input"
			@mousedown="inputMouseDown"
			@mouseup="inputMouseUp">
		</div>
		<div class="node-main">
			<div v-text="title" class="node-title"></div>
			<div v-text="description" class="node-description"></div>
		</div>
		<div class="node-port node-output" 
			@mousedown="outputMouseDown">
		</div>
		<div v-show="show.edit" class="node-edit" @click.stop="show.editPopover = !show.editPopover">
			<img src="../assets/pencil.svg" class="pencil-image">
		</div>
		<div v-show="show.editPopover" class="popover-container">
			<button class="popover-btn" @click.stop="editStep">Edit Step</button>
			<button class="popover-btn" @click.stop="editDetails">Edit Details</button>
			<button class="popover-btn" @click.stop="deleteStep">Delete Step</button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'ExperienceNode',
		props: {
			id: {
				type: Number,
				default: 1000,
				validator(val) {
					return typeof val === 'number'
				}
			},
			x: {
				type: Number,
				default: 0,
				validator(val) {
					return typeof val === 'number'
				}
			},
			y: {
				type: Number,
				default: 0,
				validator(val) {
					return typeof val === 'number'
				}
			},
			title: {
				type: String,
				default: 'Node Title'
			},
			description: {
				type: String,
				default: 'Default'
			},
			options: {
				type: Object,
				default() {
					return {
						centerX: 1024,
						scale: 1,
						centerY: 140,
					}
				}
			},
			show: {
				type: Object,
				default() {
					return {
						edit: false,
						editPopover: false
					}
				}
			}
		},
		computed: {
			nodeStyle() {
				return {
					top: this.options.centerY + this.y * this.options.scale + 'px', // remove: this.options.offsetTop + 
					left: this.options.centerX + this.x * this.options.scale + 'px', // remove: this.options.offsetLeft + 
					transform: `scale(${this.options.scale})`,
				}
			}
		},
		methods: {
			handleMousedown(e) {
				const target = e.target || e.srcElement;
				// console.log(target);
				if (target.className.indexOf('node-input') < 0 && target.className.indexOf('node-output') < 0) {
					this.$emit('nodeSelected', e);
				}
				e.preventDefault();
				this.show.edit = false;
				// this.show.editPopover = false;
			},
			handleMouseOver() {
				this.show.edit = true;
			},
			handleMouseLeave() {
				this.show.edit = false;
			},
			outputMouseDown(e) {
				this.$emit('linkingStart')
				e.preventDefault();
			},
			inputMouseDown(e) {
				e.preventDefault();
			},
			inputMouseUp(e) {
				this.$emit('linkingStop')
				e.preventDefault();
			},
			hidePopover() {
				this.show.editPopover = false;
			},
			editDetails() {
				this.hidePopover();
				this.$emit('editDetails');
			},
			editStep() {
				this.hidePopover();
				this.$emit('editStep');
			},
			deleteStep() {
				this.hidePopover();
				this.$emit('deleteStep');
			},
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
	$themeColor: rgb(255, 136, 85);
	$portSize: 10;

	.story-node {
		margin: 0;
		width: 120px;
		position: absolute;
		box-sizing: border-box;
		border: 2px solid $themeColor;
		color: #33363d;
		z-index: 1;
		opacity: .9;
		cursor: move;
		transform-origin: top left;
		.node-main {
			text-align: center;
			position: relative;
			z-index: 5;
			min-height: 120px;
			background-color: #f2f2f2;
			.node-title {
				background: $themeColor;
				color: white;
				font-size: 16px;
				padding: 6px;
			}
			.node-description {
				font-size: 14px;
				font-weight: 500;
				padding: 5px;
				max-height: 84px;
				overflow-y: auto;
			}
			.node-description p {
				margin: 0;
			}
		}
		.node-port {
			position: absolute;
			width: #{$portSize}px;
			height: #{$portSize}px;
			left: 50%;
			transform: translate(-50%);
			border: 2px solid $themeColor;
			border-radius: 100px;
			background: $themeColor;
			z-index: -1;
			&:hover {
				background: $themeColor;
				border: 1px solid #a6a6a6;
			}
		}
		.node-input {
			top: #{-2+$portSize/-2}px;
		}
		.node-output {
			bottom: #{-2+$portSize/-2}px;
		}
		.node-edit {
			position: absolute;
			right: -11px;
			top: -11px;
			font-size: 15px;
			width: 30px;
			height: 30px;
			color: $themeColor;
			cursor: pointer;
			background: white;
			border: 1px solid $themeColor;
			border-radius: 100px;
			text-align: center;
			z-index: 5;
			&:hover{
				background: #f2f2f2;
				color: white;
			}

			.pencil-image {
				width: 65%;
				height: 100%;
			}
		}
	}
	.selected {
		box-shadow: 0 0 0 2px $themeColor;
	}
	.popover-container {
		position: absolute;
		top: 0;
		right: -164px;
		background-color: white;
		width: 150px;
		border: 1px solid #f2f2f2;
	}
	.popover-btn {
		border: none;
		background: #f2f2f2;
		width: 100%;
		padding: 10px 0;
		font-family: inherit;
		font-size: 14px;
		cursor: pointer;
	}
</style>